import React from "react";
// import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { media } from "utils/style";
// import moment from "moment";

// import { cleanDateFormat } from "utils/cleanDateFormat";
// import { replaceHashValues } from "utils/replaceHashValues";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";

const CancelModal = props => {
  const {
    section_title,
    section_description,
    buttons: [exitButton, stayButton]
  } = props.modalContent.modalContent;

  return (
    <Modal {...props} contentLabel="cancel progress modal"  
    >
      <ModalTitle>        
      <H2>{convertStringToElements(section_title)}</H2>
      </ModalTitle>
      <ModalBody>
      <p>{convertStringToElements(section_description)}</p>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: '100%',
            children: exitButton.text,
            onClick: () => props.cancelProgress(),
          },
          close: {
            width: '100%',
            children: stayButton.text,
            onClick: () => props.closeModal(),
          },
        }}
      />
      {/* <Div>
        <H2>{convertStringToElements(section_title)}</H2>
        <p>{convertStringToElements(section_description)}</p>
        <ButtonContainer>
          <Button onClick={props.cancelProgress} background={exitButton.type}>
            {exitButton.text}
          </Button>
          <Button onClick={props.closeModal} background={stayButton.type}>
            {stayButton.text}
          </Button>
        </ButtonContainer> */}
    {/* </Div> */}
    </Modal >
  );
};
export default CancelModal;
const Div = styled.div`
  max-width: 480px;
`;
const ButtonContainer = styled.div`
  display: flex;
  marginTop: "56px";
  ${media.mobile`
   flex-direction: column;
  `}
`;
const H2 = styled.h2`
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 19px;
  ${media.mobile`
    margin-right: 20px;
   `}
`;